import { render, staticRenderFns } from "./BaseTableSortableColumn.vue?vue&type=template&id=fd649d0e&scoped=true"
import script from "./BaseTableSortableColumn.vue?vue&type=script&lang=js"
export * from "./BaseTableSortableColumn.vue?vue&type=script&lang=js"
import style0 from "./BaseTableSortableColumn.vue?vue&type=style&index=0&id=fd649d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd649d0e",
  null
  
)

export default component.exports